import React, { useState, useEffect } from "react";
import { isBlockedUser } from "../Utils/userFilters";

const ChatHeadCard = ({
  users,
  userProfile,
  selectedUsers,
  setSelectedUsers,
}) => {
  const [inputText, setInputText] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);

  useEffect(() => {
    const mentionStart = inputText.indexOf("@");

    if (mentionStart !== -1) {
      const query = inputText.slice(mentionStart + 1).toLowerCase();

      // Only mentionable users: have a name and are not blocked/disabled
      const usersWithName = (users || []).filter(
        (user) => user?.name && !isBlockedUser(user),
      );

      if (query) {
        const filtered = usersWithName.filter(
          (user) =>
            user.name.toLowerCase().includes(query) &&
            !selectedUsers.some((tag) => tag.id === user.id),
        );
        setFilteredUsers(filtered);
      } else {
        const availableUsers = usersWithName.filter(
          (user) => !selectedUsers.some((tag) => tag.id === user.id),
        );
        setFilteredUsers(availableUsers);
      }
    } else {
      setFilteredUsers([]);
    }
  }, [inputText, selectedUsers, users]);

  const handleInputChange = (e) => {
    setInputText(e.target.value);
  };

  const handleUserSelect = (user) => {
    const mentionStart = inputText.indexOf("@");

    const newInput = inputText.slice(0, mentionStart) + user.name + " ";

    setInputText("");
    setFilteredUsers([]);
    setSelectedUsers((prevTags) => [
      ...prevTags,
      {
        name: user.name,
        profileImage: user.profileImage,
        email: user.email,
        id: user.id,
      },
    ]);
  };

  const handleTagRemove = (id) => {
    setSelectedUsers(selectedUsers.filter((tag) => tag.id !== id));
  };

  return (
    <div className="chats-card-content">
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center gap-2">
          <div className="back-arrow-for-chats">
            <img
              className="chats-back-arrow"
              src="/icons/back-arrow.svg"
              alt="Back Arrow"
            />
          </div>
          <div className="chat-profile-image-user">
            <span className="text-heading-h3" style={{ color: "#d0d8df" }}>
              New Message
            </span>
          </div>
        </div>
        <div>
          <div
            className="chat-profile-image-user"
            data-bs-toggle="modal"
            data-bs-target="#customizeChatModal"
            style={{ cursor: "pointer" }}
          >
            <img src="/icons/customize-icon.svg" alt="Customize Icon" />
            <span
              className="text-body-b2 dwn-text"
              style={{ color: "#b3ddff" }}
            >
              Customise Chat
            </span>
          </div>
        </div>
      </div>
      <div className="new-chat-input-container mt-1">
        <span className="d-flex text-body-b3 gap-2 text-body-b3-color align-items-center">
          To:
          <div className="selected-tags">
            {selectedUsers.map((tag) => (
              <span key={tag.id} className="tag" data-user-id={tag.id}>
                <img src={tag.profileImage} alt={tag.name} />
                <span className="text-body-b2">{tag.name}</span>
                <img
                  src="/icons/cross.svg"
                  className="tag-remove"
                  alt=""
                  onClick={() => handleTagRemove(tag.id)}
                  style={{ width: "10px", height: "10px" }}
                />
              </span>
            ))}
          </div>
          <input
            className="new-mention-message message-input"
            type="text"
            value={inputText}
            onChange={handleInputChange}
            placeholder="Type @ to mention"
          />
        </span>
        <div
          className={`mention-dropdown ${
            filteredUsers.length > 0 ? "visible" : ""
          }`}
        >
          {filteredUsers.length > 0 &&
            filteredUsers.map((user) => (
              <div
                key={user.id}
                className="mention-item text-body-b2"
                data-user-id={user.id}
                onClick={() => handleUserSelect(user)}
              >
                <img
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                  }}
                  src={user.profileImage}
                  className="avatar"
                  alt={user.name}
                />
                <span>{user.name}</span>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default ChatHeadCard;
